<div class="items" *ngIf="config">
    <div class="item" *ngFor="let item of config.package" [style.background-image]="'url(' + item.image + ')'" (click)="onClickPackage(item)">
        <span class="name">{{item.name}}</span>
    </div>
</div>